import { ArrowLeft, Copy, Globe, Lock } from "lucide-react";
import { toast } from "sonner";
import { AgeBadge } from "@/components/yarn/Badges";
import { SoundToggle } from "@/components/room/SoundToggle";

export const copyText = async (text, msg = "Copied!") => {
  try {
    await navigator.clipboard.writeText(text);
    toast.success(msg);
  } catch {
    toast.error("Couldn't copy. Long-press to copy instead.");
  }
};

export function RoomHeader({ room, status, onLeave }) {
  return (
    <header className="topbar sticky top-0 z-30">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 h-16 flex items-center gap-3">
        <button className="btn-soft h-10 w-10 grid place-items-center shrink-0" onClick={onLeave} aria-label="Leave game" data-testid="leave-room-button">
          <ArrowLeft size={18} />
        </button>
        <div className="min-w-0 flex-1">
          <div className="flex items-center gap-2">
            {room.visibility === "private" ? <Lock size={14} className="shrink-0" /> : <Globe size={14} className="shrink-0" />}
            <h1 className="font-display text-lg font-semibold truncate" data-testid="room-name">{room.name}</h1>
          </div>
          <p className="text-xs text-[var(--yarn-muted)]" data-testid="connection-status">
            {status === "open" ? "Connected" : "Reconnecting..."}
          </p>
        </div>
        <AgeBadge rating={room.age_rating} testid="room-age-badge" />
        <SoundToggle />
        <button className="chip h-10 px-3 text-sm inline-flex items-center gap-1.5 tracking-widest shrink-0"
          onClick={() => copyText(room.code, "Game code copied")} data-testid="room-code-button">
          {room.code} <Copy size={14} />
        </button>
      </div>
    </header>
  );
}
